import Api from "~/service/Api";

class StripeConnectRepository {
  fetchCustomer(customerId, query = {}) {
    // Note the url points to the old phocoa countries api url.
    return Api.get(`/stripe-connect/customer/${customerId}`, query);
  }
}

export default StripeConnectRepository;
